import { useContext } from "react";
import { Box } from "@mui/material";
import { UptimeDowntimeBartList } from "./components/UptimeDowntimeBarList/UptimeDowntimeBartList.view";
import { OverallDowntimeSummary } from "pages/Corporate/components/OverallDowntimeSummary/OverallDowntimeSummary.view";
import { useStyles } from "./SummaryReport.styles";
import { WeekTrend } from "pages/Corporate/components/WeekTrend/WeekTrend.view";
import { MachineCenters } from "pages/Corporate/components/TopFiveBadActors/MachineCenters/MachineCenters.view";
import { FunctionalLocations } from "pages/Corporate/components/TopFiveBadActors/FunctionalLocations/FunctionalLocations.view";
import SummaryReportFilters from "./components/SummaryReportFilters/SummaryReportFilters.view";
import FailureCodesByFailureType from "./components/FailureCodesByFailureType/FailureCodesByFailureType.view";
import { SummaryReportDashboardContext } from "contexts/SummaryReportDashboardContext/SummaryReportDashboardContext";

const SummaryReport = () => {
    const classes = useStyles();
    const { showFilters } = useContext(SummaryReportDashboardContext);

    return (
        <>
            {showFilters && <SummaryReportFilters />}
            <Box className={classes.gridContainer}>
                <Box className={classes.UptimeDowntimeBartList}>
                    <UptimeDowntimeBartList />
                </Box>
                <Box className={classes.OverallDowntimeSummary}>
                    <OverallDowntimeSummary />
                </Box>
                <Box className={classes.MachineCenters}>
                    <MachineCenters />
                </Box>
                <Box className={classes.WeekTrend}>
                    <WeekTrend />
                </Box>
                <Box className={classes.FunctionalLocations}>
                    <FunctionalLocations />
                </Box>
                <Box className={classes.FailureCodesByType}>
                    <FailureCodesByFailureType />
                </Box>
            </Box>
        </>
    );
};

export default SummaryReport;
